import { Record } from 'immutable';
import { UPLOAD_CA } from './constants';

const InitialState = Record({
  uploading: false,
});

const initialState = new InitialState();

function fileUploadOverlayReducer(state = initialState, action = undefined) {
  switch (action.type) {
    case UPLOAD_CA:
      return state.set('uploading', true);
    case `${UPLOAD_CA}_SUCCESS`:
      return state.set('uploading', false);
    case `${UPLOAD_CA}_ERROR`:
      return state.set('uploading', false);
    default:
      return state;
  }
}

export default fileUploadOverlayReducer;
